import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationUpdateService {
  private notificationUpdateSubject = new BehaviorSubject<any>(null);

  constructor() {}

  // Emit notification update for dashboard
  emitNotificationUpdate(notifications: any) {
    this.notificationUpdateSubject.next(notifications);
  }

  // Subscribe to notification updates
  getNotificationUpdates(): Observable<any> {
    return this.notificationUpdateSubject.asObservable();
  }

  // Clear the current update
  clearUpdate() {
    this.notificationUpdateSubject.next(null);
  }
}
